import {
  ChangeDetectionStrategy,
  Component,
  computed,
  model
} from '@angular/core';
import { MatSelect, MatSelectModule } from '@angular/material/select';
import { VisualFilter } from 'src/app/pbir/visuals/VisualFilter';
import { DynamicFilterValue } from 'src/app/services/api.services';

@Component({
  selector: 'filter-editor__dynamic',
  template: `
    <div class="visual-editor-box__input">
      <label>Show data for</label>
      <mat-select class="trg-outline user-select-none w-100p h-24"
                  panelClass="trg-outline-dropdown"
                  [value]="predicate().kind"
                  (valueChange)="updatePredicate({ kind: $event })">
        @for (o of options(); track o.value) {
          <mat-option [value]="o.value" [title]="o.title">
            <span>{{o.title}}</span>
          </mat-option>
        }
       
      </mat-select>
    </div>
  `,
  styles: [`
  `],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatSelectModule],
  standalone: true
})
export class DynamicFilterComponent {
  readonly DynamicFilterValue = DynamicFilterValue;

  readonly options = computed(() => [
    {
      value: DynamicFilterValue.SpendEmployeeCode,
      title: `Logged in User`,
    },
    {
      value: DynamicFilterValue.SpendDepartmentNames,
      title: `Logged in Manager's Department(s)`,
    }
  ]);

  readonly predicate = model<Partial<VisualFilter.DynamicPredicate>>({
    kind: DynamicFilterValue.SpendEmployeeCode,
  });

  updatePredicate(changes: any) {
    this.predicate.update(x => ({
      ...x,
      ...changes
    }));
  }
}
